export enum TableCellType {
  Default = 'default',
  WithImage = 'withImage'
}
